import { render, staticRenderFns } from "./ProfileDocuments.vue?vue&type=template&id=47cbfd66&scoped=true&"
import script from "./ProfileDocuments.vue?vue&type=script&lang=js&"
export * from "./ProfileDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDocuments.vue?vue&type=style&index=0&id=47cbfd66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbfd66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47cbfd66')) {
      api.createRecord('47cbfd66', component.options)
    } else {
      api.reload('47cbfd66', component.options)
    }
    module.hot.accept("./ProfileDocuments.vue?vue&type=template&id=47cbfd66&scoped=true&", function () {
      api.rerender('47cbfd66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/ProfileDocuments.vue"
export default component.exports